<template>
    <dash
        icon="fa fa-building-o"
        titulo="FORNECEDORES"
        @click.native="$router.push({ name: 'Fornecedores' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
